/**
 * SSR-safe rules for `r-text` show more / show less.
 *
 * widget-react injects this once per library via `ComponentLibraryModule.stylesheet`.
 * Collapsing cannot be an inline style: it keys off whether a checkbox inside
 * the toggle is checked, which only CSS `:has()` can see without JavaScript.
 *
 * Every rule sits inside `@supports selector(:has(*))` and is scoped to
 * `[data-rulecms-text-truncate]` with child combinators. Without that support
 * — or without this sheet — the markup's `hidden` attributes leave the full
 * text visible and the toggle invisible, which is the progressive-enhancement
 * path on purpose.
 */
export const TEXT_LIBRARY_STYLESHEET = `
@supports selector(:has(*)) {
  [data-rulecms-text-truncate] > [data-rulecms-text-toggle] {
    display: inline;
    cursor: pointer;
    color: inherit;
    font: inherit;
  }
  [data-rulecms-text-truncate] > [data-rulecms-text-toggle]:has(> [data-rulecms-text-toggle-input]:focus-visible) {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
  [data-rulecms-text-truncate] > [data-rulecms-text-toggle] > [data-rulecms-text-show-more]:not(:has(*)),
  [data-rulecms-text-truncate] > [data-rulecms-text-toggle] > [data-rulecms-text-show-less]:not(:has(*)) {
    text-decoration: underline;
  }
  [data-rulecms-text-truncate]:not(:has(> [data-rulecms-text-toggle] > [data-rulecms-text-toggle-input]:checked)) > [data-rulecms-text-ellipsis] {
    display: inline;
  }
  [data-rulecms-text-truncate]:not(:has(> [data-rulecms-text-toggle] > [data-rulecms-text-toggle-input]:checked)) > [data-rulecms-text-rest] {
    display: none;
  }
  [data-rulecms-text-truncate]:not(:has(> [data-rulecms-text-toggle] > [data-rulecms-text-toggle-input]:checked)) > [data-rulecms-text-toggle] > [data-rulecms-text-show-less] {
    display: none;
  }
  [data-rulecms-text-truncate]:has(> [data-rulecms-text-toggle] > [data-rulecms-text-toggle-input]:checked) > [data-rulecms-text-toggle] > [data-rulecms-text-show-more] {
    display: none;
  }
}
`.trim();
